// storyblok image loaders

export const imageSquareLoader = ({ src, width, quality }) => {
  return src
    .replace('[DIMENSIONS]', `${width}x${width}`)
    .replace('[QUALITY]', quality ? quality.toString() : '75');
};

export const imageRectangleLoader = ({ src, width, quality }) => {
  return src
    .replace('[DIMENSIONS]', `${width}x0`)
    .replace('[QUALITY]', quality ? quality.toString() : '75');
};
